import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { CollapsibleImportSummary } from '../../../components/CollapsibleSummary';
import { IImportQuestionRejection } from '../projects.model';
import { mapQuestionRejectionReason } from './ImportQuestionsSummary';

interface IProps {
  isLastSummaryItem?: boolean;
  isPanelOpen: boolean;
  handlePanelToggle: () => void;
  rejectedAttributes: IImportQuestionRejection[];
  importedAttributesCount: number;
  skippedAttributesCount: number;
}

export const ImportAttributesSummary = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const getRejectionReasons = (): string[] => {
    return props.rejectedAttributes.map((x) => {
      return `${x.text} - ${t(mapQuestionRejectionReason(x.reason))}`;
    });
  };

  return (
    <>
      <CollapsibleImportSummary
        importedItemsCount={props.importedAttributesCount}
        skippedItemsCount={props.skippedAttributesCount}
        rejectionReasons={getRejectionReasons()}
        isPanelOpen={props.isPanelOpen}
        togglePanel={props.handlePanelToggle}
        isLastSummaryItem={props.isLastSummaryItem}
        importedMessage={t('attributes_imported', { count: props.importedAttributesCount })}
        skippedMessage={t('attributes_skipped', { count: props.skippedAttributesCount })}
      />
    </>
  );
});
